import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_WhatWillILookLikeWhenImOlder = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older',
			name: "What Will I Look Like When I'm Older — Try It",
			description:
				"Upload one portrait and see how you'll look at different ages. Choose from 6 age options, compare results instantly, and regenerate with one tap. Try it online.",
			url: 'https://liftapp.ai/what-will-i-look-like-when-im-older',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{
					'@id':
						'https://liftapp.ai/what-will-i-look-like-when-im-older#product',
				},
				{
					'@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older#howto',
				},
				{
					'@id':
						'https://liftapp.ai/what-will-i-look-like-when-im-older#benefits',
				},
				{ '@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older#faq' },
				{
					'@id':
						'https://liftapp.ai/what-will-i-look-like-when-im-older#why-lift',
				},
				{
					'@id':
						'https://liftapp.ai/what-will-i-look-like-when-im-older#explore-tools',
				},
				{
					'@id':
						'https://liftapp.ai/what-will-i-look-like-when-im-older#all-in-one',
				},
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older#product',
			name: "What Will I Look Like When I'm Older — Try It",
			description:
				"Upload one portrait and see how you'll look at different ages. Choose from 6 age options, compare results instantly, and regenerate with one tap. Try it online.",
			url: 'https://liftapp.ai/what-will-i-look-like-when-im-older',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photo',
					text: 'Choose a clear portrait from your device to start the age progression preview',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose an age',
					text: 'Pick one of 6 age options to see how your face changes over time',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Compare the result',
					text: 'View your original image next to the AI-generated age progression result',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Regenerate anytime',
					text: 'Try another age option and create a new version with one tap',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older#benefits',
			name: 'Who Can Benefit from AI Face Preview?',
			description:
				"Lift's AI Face Preview is useful for social media users, curious individuals, friends, content creators, and mobile users who want to preview how a face changes across different life stages.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Social media users can generate a striking before-and-after visual and share it directly from the results screen',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Curious users can explore what they might look like at 40, 60, or beyond with just one photo',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Friends and entertainment seekers can run the same photo through multiple age options and compare the results together',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Content creators can produce eye-catching face transformation visuals in seconds without any design skills',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Mobile users can upload directly from their camera roll, select an age with a single tap, and regenerate instantly',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: "What Will I Look Like When I'm Older – Before and After AI Face Aging in Lift",
				description:
					'Before and after portrait showing a young woman and her AI-generated older face version with visible aging details using the Lift face preview tool',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Face Preview?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Face Preview is a creative tool that transforms a single portrait into realistic older versions of the same face. Upload one photo, choose an age stage, and see a side-by-side comparison of your original image and the generated result.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Face Preview work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload a clear portrait, then select one of 6 age options from the on-screen control. Lift processes your photo and generates an older version of your face within seconds. Once the result appears, you can view both images together and tap Regenerate to try a different outcome.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I choose different age options?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Face Preview includes 6 age options, so you can preview different older versions of the same portrait and compare the results easily.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/what-will-i-look-like-when-im-older#why-lift',
			name: "Why Lift's AI Face Preview stands out",
			description:
				"Lift's AI Face Preview combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'What Will I Look Like Older – Young Man to Mature Face Transformation in Lift',
				description:
					'Side-by-side portrait of a young man and his AI-generated mature older version with realistic aging effect produced by Lift face preview tool',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id':
				'https://liftapp.ai/what-will-i-look-like-when-im-older#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id':
				'https://liftapp.ai/what-will-i-look-like-when-im-older#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: "What Will I Look Like When I'm Older",
					item: 'https://liftapp.ai/what-will-i-look-like-when-im-older',
				},
			],
		},
	],
};
